import { Grid, Typography } from "@mui/material";

export default function SupportingDocumentsHeader() {

    return <>
        <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
            <Typography variant='subtitle1'>
                Please note you must upload the Schedule / Programme  to include the following,
            </Typography>
            
            <Typography variant='subtitle1'>
                <ul>
                    <li>An outline of the educational content.</li>
                    <li>
                        A full schedule for the event indicating start and finish times for presentations,
                        Q&A sessions, Break time(s) and introduction/opening/closing sessions etc.
                    </li>
                    <li>Name and appointment of each speaker.</li>
                    <li>Full title of presentation/s.</li>
                    <li>
                        If programme/ schedule has not yet been finalised, please upload a draft version.
                        Submission of at least one document is required to proceed to the next step.
                    </li>
                </ul>
            </Typography>
        </Grid>
    </>
}
